<template>
  <module-list-layout :createAction="createAction" :module="module" class="p-2" v-if="amReady">
    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <moduleForm
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          formTitle="Add voip dialplan"
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-4">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search destination or dial code"></dg-text-field>
      </div>
      <div class="col-12 col-md-8">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </module-list-layout>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import smartAgGridWrapper from "@/components/smart-input-view/AgGridWrapper";

export default {
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form-manual/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  data() {
    return {
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'dialcode',
            headerName: 'Dialcode',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellClass: 'text-capitalize',
            autoHeight: true
          },
          /*{
            headerName: 'Billing',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellClass: 'text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(smartAgGridWrapper),
            cellRendererParams: {
              props: {
                inputWidth: '60px',
                fieldName: 'billing_cycle',
                saveAction: this.updateDataTableField,
                noCopy: true,
                customParams: {}
              }
            }
          },*/
          {
            width: 80,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    updateDataTableField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.data.id,
        data
      }

      this.updateEntity(apiParams).then(r => {
        afterSave()
      })
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true
    },
    getEntityListData(page) {
      this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions('voip-dialplan-api', {getEntityList: 'list', 'updateEntity' : 'update'}),
    scrollToTop () {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount () {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage (page) {
      //$router.push({name : 'module->voip-dialplan->list->page', params: {listPage: page, this.userSearch}})
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
